/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const deleteApiSocietaSocietaidSmtpConfigurationPathParamsSchema =
  z.object({
    societaId: z.coerce.number().int(),
  });

/**
 * @description No Content
 */
export const deleteApiSocietaSocietaidSmtpConfiguration204Schema = z.any();

export const deleteApiSocietaSocietaidSmtpConfigurationMutationResponseSchema =
  z.lazy(() => deleteApiSocietaSocietaidSmtpConfiguration204Schema);
